import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const SidebarInfoColumn = ({ attribute, value }) => (
	<Stack
		direction="row"
		sx={{
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			paddingBottom: '5px',
		}}
	>
		<Stack
			sx={{
				minWidth: 'fit-content',
				marginRight: '10px',
				textAlign: 'left',
			}}
		>
			<Typography variant="body2">{attribute}</Typography>
		</Stack>
		<Stack
			sx={{
				flexGrow: 1,
				textAlign: 'right',
			}}
		>
			<Typography
				variant="body2"
				sx={{
					fontWeight: 'bold',
				}}
			>
				{value}
			</Typography>
		</Stack>
	</Stack>
);

SidebarInfoColumn.propTypes = {
	attribute: PropTypes.any,
	value: PropTypes.any,
};

export default SidebarInfoColumn;
